import {
  Autocomplete,
  Card,
  Chip,
  Icon,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import DataTableHeadCell from "examples/Tables/DataTable/DataTableHeadCell";
import { useEffect, useState } from "react";
import { errorAlert, successAlert } from "utils/Functions";
import { get, post, postNoResponse } from "utils/WebService";

const PASTAS_SISTEMA = [
  {
    chave: "PATH_REMESSAS",
    descricao: "Remessas Bancárias",
    finalidade: "Arquivos de remessa bancária enviados ao banco",
    defaultPath: "D:\\Cobranca\\Remessas\\",
    icon: "upload_file",
    color: "info",
  },
  {
    chave: "PATH_RETORNOS",
    descricao: "Retornos Bancários",
    finalidade: "Arquivos de retorno bancário (.RET) importados",
    defaultPath: "D:\\Cobranca\\Retornos\\",
    icon: "download_for_offline",
    color: "success",
  },
  {
    chave: "PATH_CNAB_PAGAMENTOS",
    descricao: "Relatórios de Pagamentos CNAB",
    finalidade: "Relatórios PDF de baixas e pagamentos CNAB pós-importação",
    defaultPath: "D:\\Cobranca\\Retornos\\Pagamentos\\",
    icon: "picture_as_pdf",
    color: "error",
  },
  {
    chave: "PATH_DOCUMENTOS",
    descricao: "Documentos do Sistema",
    finalidade: "Documentos de fichas de devedores e processos jurídicos",
    defaultPath: "D:\\Cobranca\\Documentos\\",
    icon: "description",
    color: "primary",
  },
  {
    chave: "PATH_IMPORTACAO",
    descricao: "Importações",
    finalidade: "Planilhas e arquivos para cargas e importações",
    defaultPath: "D:\\Cobranca\\Importacao\\",
    icon: "drive_folder_upload",
    color: "secondary",
  },
  {
    chave: "PATH_GRAVACOES",
    descricao: "Gravações de Telefonia",
    finalidade: "Gravações das chamadas telefônicas (Nextbilling)",
    defaultPath: "D:\\Cobranca\\Gravacoes\\",
    icon: "record_voice_over",
    color: "warning",
  },
  {
    chave: "PATH_RELATORIOS",
    descricao: "Templates de Relatórios",
    finalidade: "Templates de relatórios customizados (Cobrança e Jurídico)",
    defaultPath: "D:\\Cobranca\\Relatorios\\",
    icon: "assessment",
    color: "info",
  },
  {
    chave: "PATH_EXPORTACAO_COMPARADOR_PROCESSOS",
    descricao: "Exportação Comparador de Processos",
    finalidade: "Diretório para salvar a planilha de processos não localizados para o robô",
    defaultPath: "D:\\Cobranca\\ComparadorProcessos\\",
    icon: "find_replace",
    color: "warning",
  },
];

const PROCESSOS_SISTEMA = [
  {
    chave: "OCORRENCIA_IMPORTACAO_REMESSA",
    descricao: "Importação de Remessa / Base de Dados",
    defaultText: "Ocorrência lançada quando uma ficha é importada via remessa",
  },
  {
    chave: "OCORRENCIA_DEVOLUCAO_BATIMENTO",
    descricao: "Devolução de Ficha no Batimento",
    defaultText:
      "Ocorrência lançada quando a ficha inteira é devolvida por ausência na remessa",
  },
  {
    chave: "OCORRENCIA_DEVOLUCAO_FICHA",
    descricao: "Devolução de Ficha (Operacional / Suporte)",
    defaultText:
      "Ocorrência lançada quando a ficha inteira é devolvida pelo usuário (Base de Dados) ou via Fila de Suporte",
  },
  {
    chave: "OCORRENCIA_REATIVACAO_FICHA",
    descricao: "Reativação de Ficha",
    defaultText:
      "Ocorrência lançada na reativação manual de uma ficha devolvida",
  },
  {
    chave: "OCORRENCIA_DEVOLUCAO_CONTRATO_BATIMENTO",
    descricao: "Devolução de Contrato / Dívida no Batimento",
    defaultText:
      "Ocorrência lançada quando um contrato/dívida é devolvido por ausência na remessa",
  },
  {
    chave: "OCORRENCIA_DEVOLUCAO_CONTRATO",
    descricao: "Devolução de Contrato (Operacional / Suporte)",
    defaultText:
      "Ocorrência lançada quando um contrato/dívida é devolvido pelo usuário (Base de Dados) ou via Fila de Suporte",
  },
  {
    chave: "OCORRENCIA_REATIVACAO_CONTRATO",
    descricao: "Reativação de Contrato / Dívida",
    defaultText:
      "Ocorrência lançada na reativação de um contrato previamente devolvido",
  },
  {
    chave: "OCORRENCIA_SOLICITACAO_MIGRACAO_CARTEIRA",
    descricao: "Solicitação de Migração de Carteira",
    defaultText:
      "Ocorrência lançada quando o operador solicita a migração de carteira da ficha/contrato",
  },
  {
    chave: "OCORRENCIA_EFETIVACAO_MIGRACAO_CARTEIRA",
    descricao: "Migração de Carteira (Efetivada / Aprovada)",
    defaultText:
      "Ocorrência lançada quando a migração de carteira é efetivada ou aprovada pelo suporte",
  },
  {
    chave: "OCORRENCIA_ALTERACAO_CADASTRAL",
    descricao: "Alteração Cadastral (Endereço / Telefone / E-mail)",
    defaultText:
      "Ocorrência lançada na atualização de dados de contato do devedor",
  },
  {
    chave: "OCORRENCIA_ATUALIZACAO_DEBITO",
    descricao: "Atualização de Débito / Contrato na Importação",
    defaultText:
      "Ocorrência lançada quando o saldo ou valor do contrato é atualizado no batimento/importação",
  },
  {
    chave: "OCORRENCIA_EXCLUSAO_CADASTRAL",
    descricao: "Exclusão de Dados Cadastrais",
    defaultText:
      "Ocorrência lançada na exclusão de endereços, telefones ou e-mails do devedor",
  },
  {
    chave: "OCORRENCIA_EXCLUSAO_CONTRATO",
    descricao: "Exclusão de Contrato",
    defaultText: "Ocorrência lançada na exclusão de um contrato da ficha",
  },
  {
    chave: "OCORRENCIA_FORMALIZACAO_ACORDO",
    descricao: "Formalização de Acordo",
    defaultText: "Ocorrência lançada no fechamento e formalização de um acordo",
  },
  {
    chave: "OCORRENCIA_BAIXA_PAGAMENTO",
    descricao: "Pagamento de Parcela de Acordo",
    defaultText:
      "Ocorrência lançada no pagamento de parcela intermediária de acordo",
  },
  {
    chave: "OCORRENCIA_QUITACAO_ACORDO",
    descricao: "Quitação de Acordo (Última Parcela)",
    defaultText:
      "Ocorrência lançada no pagamento da última parcela e quitação do acordo",
  },
  {
    chave: "OCORRENCIA_ENVIO_CNAB",
    descricao: "Geração / Envio de Remessa CNAB",
    defaultText:
      "Ocorrência lançada na geração e disparo de remessa bancária CNAB",
  },
  {
    chave: "OCORRENCIA_IMPORTACAO_CNAB",
    descricao: "Processamento de Retorno CNAB",
    defaultText:
      "Ocorrência lançada na leitura e baixa de boletos via arquivo retorno CNAB",
  },
  {
    chave: "OCORRENCIA_INCLUSAO_MANUAL_DEVEDOR",
    descricao: "Inclusão Manual de Devedor / Ficha",
    defaultText:
      "Ocorrência lançada quando um novo devedor / ficha é cadastrado manualmente no sistema",
  },
  {
    chave: "OCORRENCIA_INCLUSAO_MANUAL_CONTRATO",
    descricao: "Inclusão Manual de Contrato / Dívida",
    defaultText:
      "Ocorrência lançada quando um novo contrato / débito é cadastrado manualmente",
  },
  {
    chave: "OCORRENCIA_CRIACAO_HONORARIOS",
    descricao: "Cadastro de Honorários Avulsos",
    defaultText:
      "Ocorrência lançada na criação de ficha e débito de honorários avulsos (inclusive terceiros)",
  },
];

export default function ParametrizacaoSistema() {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  const [currentTab, setCurrentTab] = useState(0);
  const [ocorrenciasList, setOcorrenciasList] = useState([]);
  const [parametros, setParametros] = useState({});
  const [folderStatus, setFolderStatus] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [testingAll, setTestingAll] = useState(false);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    setLoading(true);
    try {
      const [resOcorrencias, resParametros] = await Promise.all([
        get("/tipo-ocorrencia/list-all").catch(() =>
          post("/tipo-ocorrencia/list", { pageSize: 500, page: 0 })
        ),
        get("/parametro-sistema/list").catch(() => []),
      ]);

      const listOcorrencias = Array.isArray(resOcorrencias)
        ? resOcorrencias
        : resOcorrencias?.data || resOcorrencias?.list || [];
      const apenasSistema = listOcorrencias.filter(
        (o) =>
          o.categoria === 5 ||
          o.categoriaLabel === "Sistema" ||
          o.categoria === 2 ||
          o.categoria === 3 ||
          o.categoria === 4
      );
      const listaFinal = (
        apenasSistema.length > 0 ? apenasSistema : listOcorrencias
      ).slice();
      listaFinal.sort((a, b) => {
        const nomeA = (a.nome || a.ccNome || "").toLowerCase();
        const nomeB = (b.nome || b.ccNome || "").toLowerCase();
        return nomeA.localeCompare(nomeB, "pt-BR");
      });
      setOcorrenciasList(listaFinal);

      const listParametros = Array.isArray(resParametros)
        ? resParametros
        : resParametros?.data || resParametros?.list || [];
      const paramMap = {};
      listParametros.forEach((p) => {
        paramMap[p.chave] = p;
      });

      PASTAS_SISTEMA.forEach((pasta) => {
        if (!paramMap[pasta.chave]) {
          paramMap[pasta.chave] = {
            chave: pasta.chave,
            descricao: pasta.descricao,
            valor: "",
          };
        } else if (paramMap[pasta.chave].valor === null || paramMap[pasta.chave].valor === undefined) {
          paramMap[pasta.chave].valor = "";
        }
      });

      setParametros(paramMap);
    } catch (err) {
      console.error("Erro ao carregar parametrização:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  const handlePathChange = (chave, newPath) => {
    setParametros((prev) => ({
      ...prev,
      [chave]: {
        ...prev[chave],
        chave,
        valor: newPath,
      },
    }));
    setFolderStatus((prev) => ({
      ...prev,
      [chave]: null,
    }));
  };

  const handleSelectOcorrencia = (chave, descricao, selectedOption) => {
    setParametros((prev) => ({
      ...prev,
      [chave]: {
        ...prev[chave],
        chave,
        descricao,
        tipoOcorrenciaId: selectedOption
          ? selectedOption.id || selectedOption.cvId
          : null,
        tipoOcorrenciaNome: selectedOption
          ? selectedOption.nome || selectedOption.ccNome
          : null,
      },
    }));
  };

  const handleTestSingleFolder = async (chave) => {
    const path = parametros[chave]?.valor?.trim();
    if (!path) {
      errorAlert("Informe o caminho da pasta antes de testar.");
      return;
    }
    try {
      const res = await post("/parametro-sistema/test-path", { path });
      setFolderStatus((prev) => ({
        ...prev,
        [chave]: res?.ok || res?.status === "OK" ? "OK" : "Erro",
      }));
    } catch (e) {
      setFolderStatus((prev) => ({ ...prev, [chave]: "Erro" }));
    }
  };

  const handleTestAllFolders = async () => {
    setTestingAll(true);
    try {
      const pathsToTest = PASTAS_SISTEMA.map(
        (p) => (parametros[p.chave]?.valor || "").trim()
      ).filter(Boolean);

      if (pathsToTest.length === 0) {
        setTestingAll(false);
        errorAlert("Nenhum caminho de pasta configurado para testar.");
        return;
      }

      const res = await post("/parametro-sistema/test-all-paths", pathsToTest);
      const newStatus = {};
      PASTAS_SISTEMA.forEach((p) => {
        const path = (parametros[p.chave]?.valor || "").trim();
        if (!path) {
          newStatus[p.chave] = null;
        } else {
          const st = res?.[path] || (res?.data && res.data[path]);
          newStatus[p.chave] = st === "OK" ? "OK" : "Erro";
        }
      });
      setFolderStatus(newStatus);
      successAlert(
        "Teste de permissão e existência das pastas concluído com sucesso!"
      );
    } catch (e) {
      errorAlert("Falha ao testar as pastas do sistema.");
    } finally {
      setTestingAll(false);
    }
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      PASTAS_SISTEMA.forEach((pasta) => {
        const param = parametros[pasta.chave];
        if (param) {
          postNoResponse("/parametro-sistema/save", {
            id: param.id || null,
            chave: pasta.chave,
            descricao: pasta.descricao,
            valor: param.valor !== undefined && param.valor !== null ? param.valor : "",
          });
        }
      });

      PROCESSOS_SISTEMA.forEach((item) => {
        const param = parametros[item.chave];
        if (param) {
          postNoResponse("/parametro-sistema/save", {
            id: param.id || null,
            chave: item.chave,
            descricao: item.descricao,
            tipoOcorrenciaId: param.tipoOcorrenciaId || null,
          });
        }
      });

      successAlert("Parametrização do Sistema salva com sucesso!", () =>
        loadData()
      );
    } catch (err) {
      errorAlert("Erro ao salvar a parametrização do sistema.");
    } finally {
      setSaving(false);
    }
  };

  const [migrating, setMigrating] = useState(false);

  const handleMigrarArquivosAntigos = () => {
    setMigrating(true);
    postNoResponse("/parametro-sistema/migrar-documentos-antigos", {})
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          const dev = data.devedores || {};
          const pen = data.penhorasProcessos || {};
          const msg = `Organização Concluída!\n\nAnexos de Fichas:\n- Movidos: ${dev.movidos || 0}\n- Já organizados: ${dev.jaOrganizados || 0}\n- Não encontrados: ${dev.naoEncontrados || 0}\n\nAnexos de Processos:\n- Movidos: ${pen.movidos || 0}\n- Já organizados: ${pen.jaOrganizados || 0}`;
          successAlert(msg);
        } else {
          errorAlert(data.error || "Erro ao organizar documentos antigos.");
        }
      })
      .catch((err) => {
        console.error(err);
        errorAlert("Erro ao tentar organizar os documentos antigos.");
      })
      .finally(() => {
        setMigrating(false);
      });
  };

  const [fixingPhoneDdd, setFixingPhoneDdd] = useState(false);

  const handleCorrigirDddTelefones = () => {
    setFixingPhoneDdd(true);
    postNoResponse("/parametro-sistema/corrigir-telefones-ddd", {})
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          const msg = `Correção de DDDs Concluída!\n\n- Total de Telefones Corrigidos: ${data.totalCorrigidos || 0}\n- DDDs extraídos do número (10/11 dígitos): ${data.dddExtraidosDoTelefone || 0}\n- DDDs herdados de outro telefone do mesmo devedor: ${data.dddHerdadosMesmoDevedor || 0}`;
          successAlert(msg);
        } else {
          errorAlert(data.error || "Erro ao corrigir DDDs dos telefones.");
        }
      })
      .catch((err) => {
        console.error(err);
        errorAlert("Erro ao tentar corrigir os DDDs dos telefones.");
      })
      .finally(() => {
        setFixingPhoneDdd(false);
      });
  };

  return (
    <Card sx={{ background: darkMode ? "#4B4F5C" : "#fafafa", p: 3 }}>
      {/* Navigation Tabs + Action Buttons Bar */}
      <MDBox
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={3}
        borderBottom={1}
        borderColor="divider"
        flexWrap="wrap"
        gap={1}
      >
        <Tabs
          value={currentTab}
          onChange={handleTabChange}
          sx={{
            minHeight: "unset",
            pb: 1,
            "& .MuiTabs-indicator": {
              display: "none",
            },
            "& .MuiTabs-flexContainer": {
              gap: 1.5,
              flexWrap: "wrap",
            },
            "& .MuiTab-root": {
              minHeight: "42px",
              py: 1,
              px: 2.2,
              borderRadius: "8px",
              textTransform: "none",
              fontSize: "0.85rem",
              fontWeight: 600,
              display: "inline-flex",
              flexDirection: "row",
              alignItems: "center",
              gap: 1,
              transition: "all 0.2s ease-in-out",
              border: darkMode
                ? "1px solid rgba(255, 255, 255, 0.2)"
                : "1px solid #d2d6dc",
              backgroundColor: darkMode
                ? "rgba(255, 255, 255, 0.05)"
                : "#ffffff",
              color: darkMode ? "rgba(255, 255, 255, 0.85)" : "#4b5563",
              "&:hover": {
                backgroundColor: darkMode
                  ? "rgba(255, 255, 255, 0.12)"
                  : "#f3f4f6",
                borderColor: darkMode
                  ? "rgba(255, 255, 255, 0.38)"
                  : "#9ca3af",
                color: darkMode ? "#ffffff" : "#111827",
              },
            },
            "& .Mui-selected": {
              backgroundColor: darkMode ? "#1976d2 !important" : "#1A73E8 !important",
              borderColor: darkMode ? "#1976d2 !important" : "#1A73E8 !important",
              color: "#ffffff !important",
              boxShadow: darkMode
                ? "0 4px 12px rgba(25, 118, 210, 0.45)"
                : "0 4px 10px rgba(26, 115, 232, 0.3)",
              "& .MuiIcon-root": {
                color: "#ffffff !important",
              },
            },
          }}
        >
          <Tab
            icon={
              <Icon fontSize="small" sx={{ mr: 0.5 }}>
                folder
              </Icon>
            }
            iconPosition="start"
            label="Pastas e Arquivos"
          />
          <Tab
            icon={
              <Icon fontSize="small" sx={{ mr: 0.5 }}>
                assignment
              </Icon>
            }
            iconPosition="start"
            label="Ocorrências de Cobrança"
          />
          <Tab
            icon={
              <Icon fontSize="small" sx={{ mr: 0.5 }}>
                settings
              </Icon>
            }
            iconPosition="start"
            label="Regras de Processamento"
          />
        </Tabs>

        <MDBox display="flex" gap={1} pb={1} flexWrap="wrap">
          {currentTab === 0 && (
            <>
              <MDButton
                variant="outlined"
                color="warning"
                size="small"
                onClick={handleMigrarArquivosAntigos}
                disabled={migrating}
                sx={{ color: darkMode ? "#FFB74D !important" : "inherit" }}
              >
                <Icon sx={{ mr: 1 }}>folder_zip</Icon>{" "}
                {migrating ? "Organizando..." : "Organizar Anexos Antigos"}
              </MDButton>
              <MDButton
                variant="outlined"
                color="info"
                size="small"
                onClick={handleTestAllFolders}
                disabled={testingAll}
                sx={{
                  color: darkMode ? "#64B5F6 !important" : "inherit",
                  borderColor: darkMode ? "rgba(100, 181, 246, 0.5) !important" : undefined,
                }}
              >
                <Icon sx={{ mr: 1 }}>sync</Icon> Testar Todas as Pastas
              </MDButton>
            </>
          )}

          <MDButton
            variant="outlined"
            color="info"
            size="small"
            onClick={handleCorrigirDddTelefones}
            disabled={fixingPhoneDdd}
            sx={{
              color: darkMode ? "#64B5F6 !important" : "inherit",
              borderColor: darkMode ? "rgba(100, 181, 246, 0.5) !important" : undefined,
            }}
          >
            <Icon sx={{ mr: 1 }}>phone_in_talk</Icon>{" "}
            {fixingPhoneDdd ? "Corrigindo..." : "Corrigir DDDs dos Telefones"}
          </MDButton>

          <MDButton
            variant="contained"
            color="info"
            size="small"
            onClick={handleSave}
            disabled={saving}
            sx={{
              backgroundColor: darkMode ? "#007bff !important" : undefined,
              color: "#ffffff !important",
              fontWeight: "bold",
              boxShadow: darkMode ? "0 4px 10px rgba(0, 123, 255, 0.3)" : undefined,
              "&:hover": {
                backgroundColor: darkMode ? "#0069d9 !important" : undefined,
              },
            }}
          >
            <Icon sx={{ mr: 1 }}>save</Icon> Salvar Configurações
          </MDButton>
        </MDBox>
      </MDBox>

      {/* TAB 0: PASTAS E ARQUIVOS */}
      {currentTab === 0 && (
        <MDBox
          sx={{
            background: darkMode
              ? "linear-gradient(145deg, #606472 0%, #505461 100%)"
              : "#fff",
            borderRadius: 2,
            p: 3,
          }}
        >

          <TableContainer sx={{ boxShadow: "none" }}>
            <Table sx={{ width: "100%", tableLayout: "fixed" }}>
              <TableHead sx={{ display: "table-header-group" }}>
                <TableRow>
                  <DataTableHeadCell width="22%" sorted={false}>
                    Descrição
                  </DataTableHeadCell>
                  <DataTableHeadCell width="28%" sorted={false}>
                    Finalidade
                  </DataTableHeadCell>
                  <DataTableHeadCell width="34%" sorted={false}>
                    Caminho da Pasta
                  </DataTableHeadCell>
                  <DataTableHeadCell width="8%" align="center" sorted={false}>
                    Status
                  </DataTableHeadCell>
                  <DataTableHeadCell width="8%" align="center" sorted={false}>
                    Ações
                  </DataTableHeadCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {PASTAS_SISTEMA.map((item) => {
                  const currentPath =
                    parametros[item.chave]?.valor !== undefined && parametros[item.chave]?.valor !== null
                      ? parametros[item.chave].valor
                      : "";
                  const st = folderStatus[item.chave];

                  return (
                    <TableRow key={item.chave}>
                      <TableCell
                        sx={{
                          width: "22%",
                          verticalAlign: "middle",
                          py: 1.5,
                          color: darkMode ? "#fff" : "inherit",
                        }}
                      >
                        <MDBox display="flex" alignItems="center" gap={1}>
                          <Icon color={item.color}>{item.icon}</Icon>
                          <MDTypography
                            variant="button"
                            fontWeight="medium"
                            color={darkMode ? "white" : "dark"}
                          >
                            {item.descricao}
                          </MDTypography>
                        </MDBox>
                      </TableCell>
                      <TableCell
                        sx={{
                          width: "28%",
                          verticalAlign: "middle",
                          py: 1.5,
                        }}
                      >
                        <MDTypography variant="caption" color="text">
                          {item.finalidade}
                        </MDTypography>
                      </TableCell>
                      <TableCell
                        sx={{
                          width: "34%",
                          verticalAlign: "middle",
                          py: 1.5,
                        }}
                      >
                        <MDInput
                          fullWidth
                          size="small"
                          value={currentPath}
                          onChange={(e) =>
                            handlePathChange(item.chave, e.target.value)
                          }
                          placeholder={item.defaultPath ? `Ex: ${item.defaultPath}` : "Informe o caminho da pasta..."}
                          sx={{
                            background: darkMode ? "#424550" : "#fafafa",
                            borderRadius: 1,
                          }}
                        />
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          width: "8%",
                          verticalAlign: "middle",
                          py: 1.5,
                        }}
                      >
                        {st === "OK" && (
                          <Chip
                            label="OK"
                            color="success"
                            size="small"
                            sx={{ fontWeight: "bold", color: "#fff" }}
                          />
                        )}
                        {st === "Erro" && (
                          <Chip
                            label="Erro"
                            color="error"
                            size="small"
                            sx={{ fontWeight: "bold", color: "#fff" }}
                          />
                        )}
                        {!st && (
                          <Chip
                            label="Pendente"
                            size="small"
                            variant="outlined"
                            sx={{
                              color: darkMode ? "#bbb" : "#666",
                              borderColor: darkMode ? "#666" : "#ccc",
                            }}
                          />
                        )}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          width: "8%",
                          verticalAlign: "middle",
                          py: 1.5,
                        }}
                      >
                        <MDButton
                          variant="text"
                          color="info"
                          size="small"
                          onClick={() => handleTestSingleFolder(item.chave)}
                        >
                          <Icon sx={{ mr: 0.5 }}>play_arrow</Icon> Testar
                        </MDButton>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Dica de permissões */}
          <MDBox
            mt={3}
            p={2}
            borderRadius={2}
            sx={{
              background: darkMode
                ? "rgba(255,255,255,0.05)"
                : "rgba(26,115,232,0.05)",
              border: darkMode
                ? "1px solid rgba(255,255,255,0.1)"
                : "1px solid rgba(26,115,232,0.2)",
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <Icon color="info">info</Icon>
            <MDTypography variant="button" color={darkMode ? "white" : "info"}>
              <strong>Dica:</strong> Certifique-se de que o usuário do serviço
              do sistema possui permissão de leitura e gravação nas pastas
              configuradas.
            </MDTypography>
          </MDBox>
        </MDBox>
      )}

      {/* TAB 1: OCORRÊNCIAS DE COBRANÇA */}
      {currentTab === 1 && (
        <MDBox
          sx={{
            background: darkMode
              ? "linear-gradient(145deg, #606472 0%, #505461 100%)"
              : "#fff",
            borderRadius: 2,
            p: 3,
          }}
        >
          <TableContainer sx={{ boxShadow: "none" }}>
            <Table sx={{ width: "100%", tableLayout: "fixed" }}>
              <TableHead sx={{ display: "table-header-group" }}>
                <TableRow>
                  <DataTableHeadCell width="45%" sorted={false}>
                    Processo do Sistema
                  </DataTableHeadCell>
                  <DataTableHeadCell width="35%" sorted={false}>
                    Ocorrência Vinculada
                  </DataTableHeadCell>
                  <DataTableHeadCell width="20%" sorted={false}>
                    Situação Gerada
                  </DataTableHeadCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {PROCESSOS_SISTEMA.map((item) => {
                  const currentParam = parametros[item.chave] || {};
                  const currentOcorrencia =
                    ocorrenciasList.find(
                      (o) => (o.id || o.cvId) === currentParam.tipoOcorrenciaId
                    ) || null;

                  return (
                    <TableRow key={item.chave}>
                      <TableCell
                        sx={{
                          width: "45%",
                          verticalAlign: "middle",
                          py: 1.5,
                        }}
                      >
                        <MDTypography
                          variant="button"
                          fontWeight="medium"
                          color={darkMode ? "white" : "dark"}
                        >
                          {item.descricao}
                        </MDTypography>
                        <MDTypography
                          variant="caption"
                          color="text"
                          display="block"
                        >
                          {item.defaultText}
                        </MDTypography>
                      </TableCell>
                      <TableCell
                        sx={{
                          width: "35%",
                          verticalAlign: "middle",
                          py: 1.5,
                        }}
                      >
                        <Autocomplete
                          fullWidth
                          options={ocorrenciasList}
                          getOptionLabel={(option) =>
                            option.nome || option.ccNome || ""
                          }
                          value={currentOcorrencia}
                          onChange={(e, newValue) =>
                            handleSelectOcorrencia(
                              item.chave,
                              item.descricao,
                              newValue
                            )
                          }
                          renderInput={(params) => (
                            <MDInput
                              {...params}
                              label="Selecione a Ocorrência..."
                              variant="standard"
                              fullWidth
                            />
                          )}
                          isOptionEqualToValue={(option, value) =>
                            (option.id || option.cvId) ===
                            (value?.id || value?.cvId)
                          }
                        />
                      </TableCell>
                      <TableCell
                        sx={{
                          width: "20%",
                          verticalAlign: "middle",
                          py: 1.5,
                        }}
                      >
                        <MDTypography
                          variant="button"
                          fontWeight="bold"
                          color={
                            currentOcorrencia?.situacaoFichaLabel
                              ? "info"
                              : "text"
                          }
                        >
                          {currentOcorrencia?.situacaoFichaLabel || "Nenhuma"}
                        </MDTypography>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </MDBox>
      )}

      {/* TAB 2: REGRAS DE PROCESSAMENTO */}
      {currentTab === 2 && (
        <MDBox
          sx={{
            background: darkMode
              ? "linear-gradient(145deg, #606472 0%, #505461 100%)"
              : "#fff",
            borderRadius: 2,
            p: 3,
          }}
        >
          <MDBox p={2}>
            <MDTypography
              variant="body2"
              color={darkMode ? "white" : "text"}
              mb={2}
            >
              Regras e parâmetros adicionais de execução (processamentos em
              segundo plano, agendamentos e notificações) estão operantes com os
              valores padrão do sistema.
            </MDTypography>
          </MDBox>
        </MDBox>
      )}
    </Card>
  );
}
